import { createSelector } from 'reselect';
import { carrierAssignInitialState } from './../../reducers/carrierAssign/reducer';
import { myLoadInitialState } from './../../reducers/myload/reducer';

export const selectData = (state: any) => state.carrierAssigned;
export const selctCarrierData = (state: any) =>
  (state && state.myload && state.myload.carrierAssigned) ||
  myLoadInitialState.carrierAssigned;
export const selctAssignedData = (state: any) =>
  (state && state.myload && state.myload.driverAssigned) ||
  myLoadInitialState.driverAssigned;
export const selctIntransitData = (state: any) =>
  (state && state.myload && state.myload.inTransit) ||
  myLoadInitialState.inTransit;
export const selctDeliveredData = (state: any) =>
  (state && state.myload && state.myload.deliveredNeedsPaperWork) ||
  myLoadInitialState.deliveredNeedsPaperWork;
  export const selctDeliveredWithPPWKData = (state: any) =>
  (state && state.myload && state.myload.deliveredWithPaperWork) ||
  myLoadInitialState.deliveredWithPaperWork;
  export const selctCarrierTenderedData = (state: any) =>
  (state && state.myload && state.myload.carrierTendered) ||
  myLoadInitialState.carrierTendered;  
  export const selctMyDriverShipments = (state: any) =>
    (state && state.myload && state.myload.myDriverShipments) ||
    myLoadInitialState.myDriverShipments; 


export const getShowToasterValue = () =>
  createSelector(
    [selectData],
    ShowToaster =>
      ShowToaster.showToaster || carrierAssignInitialState.showToaster
  );

export const getCarrierLoads = () =>
  createSelector(
    selctCarrierData,
    carrierAssigned => carrierAssigned || myLoadInitialState.carrierAssigned
  );

export const getDriverList = () =>
  createSelector(
    [selectData],
    DriverList =>
      (DriverList && DriverList.DriverList) ||
      carrierAssignInitialState.DriverList
  );

export const getAssignedLoads = () =>
  createSelector(selctAssignedData, driverAssigned => driverAssigned);
export const getAssignShipmentDriverResponse = () =>
  createSelector(
    [selectData],
    carrierAssigned =>
      carrierAssigned.assignShipmentDriverResponse ||
      carrierAssignInitialState.assignShipmentDriverResponse
  );

export const getUnAssignShipmentDriverResponse = () =>
  createSelector(
    [selectData],
    carrierAssigned =>
      carrierAssigned.unAssignShipmentDriverResponse ||
      carrierAssignInitialState.unAssignShipmentDriverResponse
  );

export const getInTransitLoad = () =>
  createSelector(
    selctIntransitData,
    inTransit => inTransit || myLoadInitialState.inTransit
  );

export const getStartTripShipment = () =>
  createSelector(
    selectData,
    shipmentData => shipmentData && shipmentData.shipmentForStartTrip
  );

export const getStartTripShipmentTimeStamp = () =>
  createSelector(
    selectData,
    shipmentData => shipmentData && shipmentData.timestamp
  );

export const getDeliveredLoad = () =>
  createSelector(
    [selctDeliveredData],
    delivered => delivered || myLoadInitialState.deliveredNeedsPaperWork
  );
  export const getCarrierTenderedLoad = () =>
  createSelector(
    [selctCarrierTenderedData],
    carrierTendered => carrierTendered || myLoadInitialState.carrierTendered
  );
  export const getMyDriverShipments = () =>
    createSelector(
      [selctMyDriverShipments],
      myDriverShipments => myDriverShipments || myLoadInitialState.myDriverShipments
  );
  export const getDeliveredWithPPWKLoad = () =>
  createSelector(
    [selctDeliveredWithPPWKData],
    delivered => delivered || myLoadInitialState.deliveredWithPaperWork
  );
export const getLoadForAssignDriver = () =>
  createSelector(selectData, state => {
    return state.loadForAssignDriver || {};
  });

export const getPredecessorShipment = () =>
  createSelector(selectData, state => state.predecessorShipment || carrierAssignInitialState.predecessorShipment)
export const getSuccessorShipment = () =>
  createSelector(
    selectData,
    carrierAssigned => carrierAssigned && carrierAssigned.successorShipmentResponse
  );

